import React from 'react';
import PropTypes from 'prop-types';
import {
  Components, Utils, translate,
} from 'versafleet-core';
import { connect } from 'react-redux';
import ReduxActions from 'reduxActions';

const Helper = Utils.Helper;

class ActionPanelFilterCustomFieldButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      parentInfo: null,
      parentOptions: [],
      childOptions: [],
    };
  }

  componentDidMount() {
    this.props.dispatch(ReduxActions.customFieldGroup.fetchOptionCustomFieldGroupList());
  }

  componentDidUpdate(prevProps) {
    if (prevProps.optionCustomFieldGroups !== this.props.optionCustomFieldGroups) {
      this._getParentOptions(this.props.optionCustomFieldGroups);
    }

    if (prevProps.customFieldDescription !== this.props.customFieldDescription) {
      this._getChildOptions(this.props.customFieldDescription);
    }
  }

  _getParentOptions(optionCustomFieldGroups) {
    const parentOptions = [];
    optionCustomFieldGroups.forEach((fieldGroup) => {
      fieldGroup.custom_field_descriptions
        .filter(field => ['text', 'number', 'dropdown', 'choice', 'numeric_dropdown'].includes(field.field_type))
        .forEach((field) => {
          parentOptions.push({
            groupName: fieldGroup.name,
            value: field.id,
            text: field.name,
            row: (
              <div>
                <div>{field.name}</div>
                <div>{fieldGroup.name}</div>
              </div>
            ),
          });
        });
    });

    this.setState({ parentOptions });
  }

  _getChildOptions(customFieldDescription) {
    // eslint-disable-next-line camelcase
    const customFields = customFieldDescription?.custom_fields || [];
    const isNumericDropdown = customFieldDescription?.field_type === 'numeric_dropdown';
    const options = customFieldDescription?.options ?? [];
    let childOptions;
    if (isNumericDropdown) {
      childOptions = customFields.reduce((acc, field) => {
        const matchedOption = options.find(opt => String(opt.text) === String(field.subvalue));
        if (matchedOption) {
          acc.push({ text: matchedOption.text, value: matchedOption.text });
        }
        return acc;
      }, []);
    } else {
      childOptions = customFields.map(field => ({
        text: field.value,
        value: field.value,
      }));
    }
    childOptions = Helper.removeDuplicates(childOptions, 'value');

    this.setState(prevState => ({
      ...prevState,
      childOptions,
    }));
  }

  onParentChange(value) {
    const { date } = this.props;
    const filter = { date };
    this.props.childOnChange(null, false);

    if (!value) {
      this.setState(prevState => ({
        ...prevState,
        parentInfo: null,
      }));
    }

    const cfd = this.state.parentOptions.find(field => field.value === value);
    if (!Helper.isNullOrUndefined(cfd)) {
      this.setState(prevState => ({
        ...prevState,
        parentInfo: cfd.groupName,
      }));
      this.props.dispatch(ReduxActions.customFieldGroup.fetchCustomFieldDescription(
        cfd.value, filter,
      ));
    }
    this.props.parentOnChange(value, true);
  }

  render() {
    const {
      id, strings, className, parentValue, childValue,
    } = this.props;

    const { parentInfo, parentOptions, childOptions } = this.state;
    return (

      <Components.ActionPanel.DropdownButton
        className={className}
        id={Helper.isNullOrUndefined(id) ? undefined : `${id}__dropdown-button`}
        showArrow
        text={strings.text}
      >
        <Components.ActionPanel.FilterNestedSearch
          childEmptyMessage={strings.childEmptyMessage}
          childLabel={strings.childLabel}
          childOnChange={value => this.props.childOnChange(value, true)}
          childOptions={childOptions}
          childPlaceholder={strings.childPlaceholder}
          childValue={childValue}
          id={Helper.isNullOrUndefined(id) ? undefined : `${id}__filter-custom-field`}
          parentInfo={!Helper.isNullOrUndefined(parentValue) ? parentInfo : null}
          parentLabel={strings.parentLabel}
          parentOnChange={value => this.onParentChange(value)}
          parentOptions={parentOptions}
          parentPlaceholder={strings.parentPlaceholder}
          parentValue={parentValue}
          showChild={!Helper.isNullOrUndefined(parentValue)}
        />
      </Components.ActionPanel.DropdownButton>
    );
  }
}

ActionPanelFilterCustomFieldButton.displayName = 'Action Panel Custom Field Button';

ActionPanelFilterCustomFieldButton.propTypes = {
  childOnChange: PropTypes.func.isRequired,
  childValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  customFieldDescription: PropTypes.shape({}),
  date: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]).isRequired,
  dispatch: PropTypes.func.isRequired,
  id: PropTypes.string,
  optionCustomFieldGroups: PropTypes.arrayOf(PropTypes.shape()),
  parentOnChange: PropTypes.func.isRequired,
  parentValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  strings: PropTypes.shape({
    parentPlaceholder: PropTypes.string,
    childPlaceholder: PropTypes.string,
    childEmptyMessage: PropTypes.string,
    text: PropTypes.string,
    childLabel: PropTypes.string,
    parentLabel: PropTypes.string,
  }).isRequired,
};

ActionPanelFilterCustomFieldButton.defaultProps = {
  childValue: null,
  className: '',
  customFieldDescription: null,
  id: '',
  optionCustomFieldGroups: [],
  parentValue: null,
};

function mapStateToProps(state, ownProps) {
  const { customFieldGroup } = state;

  let customFieldDescription = null;
  if (!Helper.isNullOrUndefined(ownProps.parentValue)) {
    customFieldDescription = customFieldGroup.customFieldDescriptions[ownProps.parentValue];
  }

  return {
    optionCustomFieldGroups: customFieldGroup.optionCustomFieldGroups || [],
    customFieldDescription,
  };
}

export default connect(mapStateToProps)(translate('Task.filter.customField')(ActionPanelFilterCustomFieldButton));
